<template>
  <VAvatar :size="size" :color="getColor()">
    <img
      v-if="avatar"
      :src="avatar"
      :alt="`${candidate.lastName} ${candidate.firstName}`"
    >
    <VIcon v-else-if="emptyIcon" :size="Math.round(size*0.75)">
      {{ emptyIcon }}
    </VIcon>
    <span v-else class="headline">
      {{ candidate.lastName.charAt(0) }}{{ candidate.firstName.charAt(0) }}
    </span>
  </VAvatar>
</template>

<script>
import { candidatePhotoType } from '@/enums';

export default {
  name: 'CandidateAvatar',
  props: {
    candidate: {
      type: Object,
      required: true,
    },
    size: {
      type: [Number, String],
      required: true,
    },
    photoType: {
      type: String,
      default: candidatePhotoType.S50,
    },
    emptyIcon: {
      type: String,
      default: 'mdi-account-outline',
    },
  },
  computed: {
    avatar() {
      if (!this.candidate.photoUrl || !this.candidate.photos) {
        return null;
      }

      return this.candidate.photoUrl
        ? this.candidate.photoUrl
        : this.candidate.photos.find((p) => p.type === this.photoType);
    },
  },
  methods: {
    getColor() {
      if (this.emptyIcon) {
        return 'grey lighten-3';
      }

      const colors = ['teal', 'indigo', 'blue', 'cyan'];
      const i = (this.candidate.firstName.length + this.candidate.lastName.length) % colors.length;

      return `${colors[i]} lighten-4`;
    },
  },
};
</script>
